import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './NavBar.css';

function NavBar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className={`navbar ${isMenuOpen ? 'open' : ''}`}>
      <div className="nav-left">
        <div className="logo">
          ShareFlix By Ajay
        </div>
        <Link to="/" className="nav-link">Home</Link>
        
      </div>
      <div className={`nav-options ${isMenuOpen ? 'open' : ''}`}>
        <Link to="/" className="nav-link">Movies</Link>
        <Link to="/" className="nav-link">TV Shows</Link>
        <Link to="/" className="nav-link">My List</Link>
      </div>
      <div className="nav-right">
        <Link to="/login" className="nav-link">Sign up</Link>
        <img className="avatar" src="https://ajayv.netlify.app/images/c4.jpg" alt="Avatar" />
        <div className="menu-toggle" onClick={toggleMenu}>
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
        </div>
      </div>
    </div>
  );
}

export default NavBar;
